import { observer } from 'mobx-react';
import { useState } from 'react';

import EPTable from '@/comp/EPTable';
import { EngineTab, permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { VersionHistoryContainer } from './styled';

import {
  emptyData,
  getFormattedEngineVersion,
  getVersionHistoryColumns,
  handleVersionClick,
  onPublishPreviousVersion,
} from './VersionHistory.utils';
import { RevertToVersionModal } from './RevertToVersionModal';
import { ViewSnapshotModal } from './ViewSnapshotModal';
import VersionAlert from './VersionAlert';

const VersionHistory = observer(() => {
  const { tvalue } = useMeasurement();
  const { permissionStore, engineStore } = useStores();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [selectedModalRow, setSelectedModalRow] = useState({
    versionNumber: '',
    status: '',
  });

  const [modalText, setModalText] = useState('');

  const [hasTriedToSubmit, setHasTriedToSubmit] = useState(false);

  const [activeTab, setActiveTab] = useState(EngineTab.StationConfiguration);

  const [isLoadingRevert, setIsLoadingRevert] = useState(false);

  const [confirmationModalInfo, setConfirmationModalInfo] = useState({
    open: false,
    modalText: undefined,
    actionHandler: undefined,
  });

  const getDataSource = () => (engineStore.versionHistory?.length ? engineStore.versionHistory : emptyData);

  const handleClick = rowData =>
    handleVersionClick({
      rowData,
      engineStore,
      tvalue,
      setSelectedModalRow,
      setIsViewModalOpen,
    });

  const onConfirmationModalClose = () => setIsModelOpen(false);

  const onConfirmationModalOpen = versionData => {
    setSelectedVersion(versionData);
    setIsModelOpen(true);
  };

  const handlePublish = onPublishPreviousVersion({
    selectedVersion,
    tvalue,
    engineStore,
    setIsLoadingRevert,
    setIsModelOpen,
    setModalText,
  });

  const columns = getVersionHistoryColumns({
    permissionStore,
    engineStore,
    onConfirmationModalOpen,
    permissions,
  });

  return (
    <>
      <VersionAlert engineVersion={engineStore.engineVersion} />
      <VersionHistoryContainer>
        <>
          <EPTable
            columns={columns}
            dataSource={getDataSource()}
            pagination={false}
            className="table"
            scroll={{ y: window.innerHeight - 340 }}
            rowKey="id"
            rowClassName="table-row"
            onRow={record => {
              return {
                onClick: () => handleClick(record),
              };
            }}
          />
          <RevertToVersionModal
            isOpen={isModelOpen}
            onOk={handlePublish}
            onCancel={onConfirmationModalClose}
            isLoading={isLoadingRevert}
            version={selectedVersion ? `${getFormattedEngineVersion(selectedVersion.version)}` : ''}
            modalText={modalText}
            setModalText={setModalText}
          />

          <ViewSnapshotModal
            isOpen={isViewModalOpen}
            onClose={() => setIsViewModalOpen(false)}
            selectedVersion={selectedModalRow}
            isCentrifugalOnly={engineStore.isCentrifugalOnlyStation}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hasTriedToSubmit={hasTriedToSubmit}
            setHasTriedToSubmit={setHasTriedToSubmit}
            confirmationModalInfo={confirmationModalInfo}
            setConfirmationModalInfo={setConfirmationModalInfo}
          />
        </>
      </VersionHistoryContainer>
    </>
  );
});

export default VersionHistory;
